import { createStyle } from '@gluestack-style/react';

export const TabsTabList = createStyle({
  flexDirection: 'row',
  alignSelf: 'stretch',
  width: '100%',
  rounded: '$full',
});
